<template>
    <v-card hover flat>
        <v-form ref="form" v-model="valid" lazy-validation enctype="multipart/form-data">
          <v-card-title>
            <h3 class="headline mb-0"><span style="color: #9C1A1A">Asignar Permisos a los Roles</span></h3>
          </v-card-title>
          <v-card-text>

            <v-flex xs12>
                <v-autocomplete
                    v-model="form.permission_role"
                    :disabled="isUpdating"
                    :items="permissions"
                    filled
                    chips
                    color="blue-grey lighten-2"
                    label="Permisos"
                    item-text="name"
                    item-value="id"
                    multiple
                    required
                    :rules="[v => !!v || 'Permiso requerido']"
                >
                    <template v-slot:selection="data">
                        <v-chip
                            :selected="data.selected"
                            close
                            class="chip--select-multi"
                            @input="remove(data.item)"
                        >
                        {{ data.item.name }}
                        </v-chip>
                    </template>
                    <template v-slot:item="data">
                        <template v-if="typeof data.item !== 'object'">
                            <v-list-tile-content v-text="data.item"></v-list-tile-content>
                        </template>
                        <template v-else>
                            <v-list-tile-content>
                                <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                            </v-list-tile-content>
                        </template>
                    </template>
                </v-autocomplete>
            </v-flex>

          </v-card-text>
          <v-card-actions>
            <v-btn @click="cerrarDialog()">Cerrar</v-btn>
            <v-spacer></v-spacer>
            <v-btn :loading="loading" class="primary" @click="submit">Guardar</v-btn>
          </v-card-actions>
        </v-form>
    </v-card>
</template>

<script>
import Form from 'vform'
import axios from 'axios'

export default {

    props: {
        id: {
            type: Number,
            required: true
        },
        loading: {
            type: Boolean,
            required: true
        }
    },

    watch: {
      isUpdating (val) {
        if (val) {
          setTimeout(() => (this.isUpdating = false), 3000)
        }
      },
    },

    data: () => ({
        permissions: [],
        autoUpdate: true,
        valid: false,
        isUpdating: false,
        form: new Form({
            permission_id: null,
            permission_role: [],
        }),
        formOld: new Form({
            permission_id: null,
            permission_role: [],
        })
    }),

    mounted () {
        this.getAllPermissions()
    },

    methods: {

        async getAllPermissions () {
            this.$emit('loadingResponse', true)
            await axios.get(`/api/permissions/admin/getAllPermissionRole/${this.id}`)
              .then(res => {
                  //console.log(res, 'data')
                  this.permissions = res.data.allpermission;
                  this.form.permission_role = res.data.permissionrole;
              })
              .finally(() => this.$emit('loadingResponse', false));
        },

        async submit () {
            if (this.$refs.form.validate()) {
                this.form.permission_id = this.id
                this.$emit('loadingResponse', true)
                await axios.post(`/api/permissions/admin/updatePermissionRole`, this.form)
                    .then(res => {
                        //console.log()
                        this.$store.dispatch('responseMessage', {
                            type: 'success',
                            text: 'Permisos asignados con exito!'
                        })
                    })
                    .catch(error => {
                        console.log(error.response)
                    })
                    .finally(() => this.$emit('loadingResponse', false));
                this.cerrarDialog()
            }
        },

        cerrarDialog () {
            this.$emit('closeDialogPermissionRole')
            this.$nextTick(() => {
                // this.$refs.form.resetValidation()
                this.$emit('loadingResponse', false)
            })
        },

        remove (item) {
            const index = this.form.permission_role.indexOf(item.id)
            if (index >= 0) this.form.permission_role.splice(index, 1)
        },

    }

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/form/formRolePermission.vue